import { Helmet } from "react-helmet-async";
import { site } from "../data/site";
import type { JsonLd } from "../lib/jsonld";

type Props = {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
  noindex?: boolean;
  jsonLd?: JsonLd | JsonLd[];
};

export default function Seo({
  title,
  description = site.description,
  path = "/",
  image = site.defaultOgImage,
  noindex = false,
  jsonLd,
}: Props) {
  const fullTitle = title ? `${title} · ${site.name}` : `${site.name} — Micro-crèches en Normandie`;
  const url = `${site.url}${path}`;
  const fullImage = image.startsWith("http") ? image : `${site.url}${image}`;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <html lang="fr" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:locale" content={site.locale} />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={fullImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
